import { throwOnError } from './utils';

type Paginated<T> = {
  rows: T[];
  count: number;
  pagination: {
    current: number;
    has_next: boolean;
    has_prev: boolean;
    max_page: number;
    per_page: number;
  };
};

type GetiTrustRequestsResponse = Paginated<{
  id: number;
  private_money_name: string | null;
  organization: {
    code: string;
    name: string;
  };
  user: {
    name: string;
  };
  created_at: string;
}>;

export const getiTrustRequests = (query = '') =>
  fetch(`/api/itrust-requests?${query}`, {
    method: 'GET',
    credentials: 'same-origin',
  }).then(throwOnError<GetiTrustRequestsResponse>);
